import { IDummyProps } from './types';

const animationBgColor = 'var(--epods--skeleton-background-animation)';
const animationStripeColor = 'var(--epods--skeleton-background-animation-stripe)';
const animationGradient = `linear-gradient(135deg, ${animationBgColor}, ${animationBgColor}, ${animationBgColor}, ${animationBgColor}, ${animationBgColor}, ${animationBgColor}, ${animationStripeColor}, ${animationBgColor}, ${animationBgColor}, ${animationBgColor}, ${animationBgColor}, ${animationBgColor})`;

export const rootStyle = ({ borderRadius, animation, rows }: IDummyProps) => {
	const background = !!rows
		? {}
		: animation
			? { backgroundImage: animationGradient }
			: { backgroundImage: 'var(--epods--skeleton-background)' };

	return {
		borderRadius: borderRadius ? borderRadius : 'var(--epods--skeleton-border-radius)',

		...background,
	};
};

export const rowStyle = ({ borderRadius, rowHeight, animation }: IDummyProps) => {
	const background = animation
		? { backgroundImage: animationGradient }
		: { backgroundImage: 'var(--epods--skeleton-background)' };

	return {
		height: rowHeight ? rowHeight : 'var(--epods--skeleton-row-height)',
		marginBottom: 'var(--epods--skeleton-margin-bottom)',
		borderRadius: borderRadius ? borderRadius : 'var(--epods--skeleton-border-radius)',

		...background,
	};
};
